import request from 'utils/request';
import { useState } from 'react';

interface Props {
  file: any;
  onStart: () => void;
  onFinished: () => void;
}

async function updateCJEventAttachment(props: Props) {
  const { onStart, onFinished, file } = props;

  onStart();

  const requestURL = '/upload';
  const formData = new FormData();

  formData.append('file', file);

  const result = await request(requestURL, {
    method: 'POST',
    body: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  onFinished();
  return result;
}

export function useUpdateCJEventAttachment() {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const upload = ({ file }: { file: any }) =>
    updateCJEventAttachment({
      file,
      onStart: () => setIsUploading(true),
      onFinished: () => setIsUploading(false),
    });

  return {
    upload,
    isUploading,
  };
}
